import { render, staticRenderFns } from "./GenericDetection.vue?vue&type=template&id=6cda0ea6"
import script from "./GenericDetection.vue?vue&type=script&lang=js"
export * from "./GenericDetection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports